import styled from '@emotion/styled'
import { Paragraph } from 'components/patterns/Typography'

export const StyledParagraph = styled(Paragraph)`
  margin-top: 3px;
`
